import { MotionConfig } from 'motion/react';
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router';
import { DialogHost, ToastHost } from './ui/primitives';
import { AppEffects } from './ui/shell/AppEffects';
import { AppNavigator } from './ui/shell/AppNavigator';
import { QuickActionHost } from './ui/shell/screens';
import { StartupGate } from './ui/shell/StartupGate';
import { UpdatePrompt } from './ui/shell/UpdatePrompt';

/**
 * Root composition (Flutter MyApp, spec 01 §5): router, app-wide effects, the
 * startup gate, then the navigator (gates or the signed-in shell). Hosts for
 * imperative overlays are mounted once, above every shell layer.
 * `MotionConfig reducedMotion="user"` is a safety net under the components'
 * own reduced-motion handling: any `motion` transform or layout animation
 * that misses it still honours the system setting.
 */
export function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <AppEffects />
        <StartupGate>
          <AppNavigator />
        </StartupGate>
        <UpdatePrompt />
        <Suspense fallback={null}>
          <QuickActionHost />
        </Suspense>
        <DialogHost />
        <ToastHost />
      </BrowserRouter>
    </MotionConfig>
  );
}
